import { IconArrowDown } from "@/app/(site)/_components/Atoms/Icons"

export const Anchors = ({
    featureAnchors
}: {
    featureAnchors: { anchor: string; title: string }[]
}) => {
    if (!featureAnchors) return null
    return (
        <ul className="flex flex-col gap-y-4">
            {featureAnchors?.map(({ anchor, title }: any, index: number) => {
                if (!title || typeof title !== "string") return null
                return (
                    <li
                        key={anchor + index}
                        className="inline-flex items-center gap-x-4 py-4 text-col-text-secondary Trim_Mono_POC_Text_12_130_-3_400_uppercase lg:py-2"
                    >
                        <a href={`#${typeof anchor === "string" ? anchor : ""}`}>
                            {title}
                        </a>
                        <IconArrowDown className="h-12 w-12" />
                    </li>
                )
            })}
        </ul>
    )
}
